import { render, staticRenderFns } from "./notifications-templates-grid.html?vue&type=template&id=7d771ef9&scoped=true&"
import script from "./notifications-templates-grid.ts?vue&type=script&lang=ts&"
export * from "./notifications-templates-grid.ts?vue&type=script&lang=ts&"
import style0 from "./notifications-templates-grid.scss?vue&type=style&index=0&id=7d771ef9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d771ef9",
  null
  
)

export default component.exports